import React from 'react';
import { useMechanicalRulesStepStyles } from './MechanicalRulesStepStyles';
import { useGetClientsWithConfigsQuery } from 'features/clients/clientConfigSlice';
import LoadingSpinner from 'components/LoadingSpinner';
import AddRule from 'features/clients/contracts/MechanicalWorkConfig/AddRule';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_ACTIVITY_PRICING_STEP_KEYS } from '../createActivityAndPricingConsts';
import { saveStepData } from '../createActivityAndPricingStateSlice';

const MechanicalRulesStep = () => {
    const classes = useMechanicalRulesStepStyles();
    const dispatch = useDispatch();
    const activityDetails = useSelector(
        state => state.createActivityAndPricingState.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS]
    );
    const rulesFromStore = useSelector(
        state => state.createActivityAndPricingState.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES]
    );
    const rulesData = rulesFromStore || {};

    const { data: clientsWithConfigs, isLoading: isLoadingClients } = useGetClientsWithConfigsQuery(null);

    const filteredClientsWithConfigs = clientsWithConfigs?.filter(c => c.config?.mechanicalsConfig?.useMechanicals === true);

    const editingRuleKeys = rulesData.editingRuleKeys || [];
    const rulesList = rulesData.rulesList || {};

    const onRuleUnsavedChanges = (ruleKey, hasUnsaved) => {
        const nextEditingRuleKeys = hasUnsaved
            ? (editingRuleKeys.includes(ruleKey) ? editingRuleKeys : [...editingRuleKeys, ruleKey])
            : editingRuleKeys.filter(key => key !== ruleKey);

        const someRuleHasUnsavedEdits = nextEditingRuleKeys.length > 0;

        if (
            rulesData.someRuleHasUnsavedEdits === someRuleHasUnsavedEdits
            && rulesData.editingRuleKeys === nextEditingRuleKeys
        ) {
            return;
        }

        dispatch(saveStepData({
            stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES,
            data: {
                editingRuleKeys: nextEditingRuleKeys,
                someRuleHasUnsavedEdits
            }
        }));
    };

    if (isLoadingClients) {
        return <LoadingSpinner loading={true} />;
    }

    return (
        <div className={classes.container}>
            <div className={classes.sectionHeader}>
                <h3>Configure Automation Rules for {activityDetails?.name}</h3>
                <p>Set up SLA rules that will automatically trigger this activity based on conditions.</p>
            </div>

            <AddRule
                clientId={null}
                lotId={null}
                clientLots={[]}
                mechanicalsRulesToEdit={rulesList}
                setMechanicalsRulesToEdit={(newRule) => {
                    dispatch(saveStepData({
                        stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES,
                        data: {
                            rulesList: newRule
                        }
                    }));
                }}
                selectLot={true}
                presetActivityData={activityDetails}
                clientsWithConfigs={filteredClientsWithConfigs}
                allowClientSelection={true}
                onUnsavedChanges={onRuleUnsavedChanges}
                buttonStyle={{}}
            />
        </div>
    );
};

export default MechanicalRulesStep;
